import { gettext } from '@eventbrite/i18n';
import { EventTypeConfig } from './types';

//Artist Button Texts
export const getArtistTranslatedTexts = () => ({
    VIEW_LESS: gettext('View less').toString(),
    VIEW_ALL: gettext('View all').toString(),
});

export const getEventTypeConfig: () => EventTypeConfig = () => ({
    lineup: {
        label: gettext('Lineup').toString(),
        role: gettext('Headliner').toString(),
    },
    artists: {
        label: gettext('Artists').toString(),
        role: gettext('Featured').toString(),
    },
    speakers: {
        label: gettext('Speakers').toString(),
        role: gettext('Keynote').toString(),
    },
    performers: {
        label: gettext('Performers').toString(),
        role: gettext('Headliner').toString(),
    },
});
